﻿// Import legacy components
import { UmbracoForm } from '@/legacy/js/umbraco-form.js';

// Bind legacy components to the global window object
window.UmbracoForm = UmbracoForm;

// Initialize legacy components
UmbracoForm.init();
